import { getServiceLayerEmbedCredentials, serviceLayerWithCredentialsLoader } from '@/assets/js/mapUtils';
import { Collection } from 'ol';
import { Tile as TileLayer } from 'ol/layer';
import { WMTS, XYZ } from 'ol/source';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import { get } from 'vuex-pathify';

export default {
  computed: {
    basemapSchema: get('layers/layersSchemaByScope@basemap@[0]'),
    basemapLayers: get('layers/basemapLayers'),
    blankBasemapVisible: get('admin/settingsValues@basemap_blank_visible'),
  },
  methods: {
    changeMapBasemap(id) {
      const r = this.getLayerById('basemap');
      let collection = [];
      if (this.basemapLayers[id]) {
        collection = [this.getBasemapLayerInstance(this.basemapLayers[id])];
      }
      r.setLayers(new Collection(collection));
    },
    getEmptyBasemap() {
      return {
        id: null,
        service_type: 'empty',
      };
    },
    getBasicBasemap() {
      return Object.values(this.basemapLayers).find(layer => layer.role === 'basemap');
    },
    getBasicBasemapLayer() {
      const basicBasemapMetadata = this.getBasicBasemap();
      return this.getBasemapLayerInstance(basicBasemapMetadata ?? this.getEmptyBasemap());
    },
    getFirstBasemap() {
      const firstVisibleLayer = this.basemapSchema?.layers.find(layer => layer.visible);
      return firstVisibleLayer ? this.basemapLayers?.[firstVisibleLayer?.id] : this.getEmptyBasemap();
    },
    getFirstBasemapLayer() {
      const firstBasemapMetadata = this.getFirstBasemap();
      if (!firstBasemapMetadata) {
        console.warn('Could not properly read basemap schema. Fallback to basic basemap.');
        return this.getBasicBasemapLayer();
      }
      return this.getBasemapLayerInstance(firstBasemapMetadata);
    },
    getBasemapLayerInstance(metadata) {
      switch (metadata.service_type) {
        case 'xyz': {
          return new TileLayer({
            source: new XYZ({
              url: metadata.url,
              ...(![undefined, null].includes(metadata.parameters?.minZoom)
                ? { minZoom: metadata.parameters.minZoom }
                : {}),
              ...(![undefined, null].includes(metadata.parameters?.maxZoom)
                ? { maxZoom: metadata.parameters.maxZoom }
                : {}),
            }),
            name: 'basemapLayer',
          });
        }
        case 'wmts': {
          const { format, version, CRS } = metadata.parameters;
          const credentials = getServiceLayerEmbedCredentials(metadata.url);
          return new TileLayer({
            name: 'basemapLayer',
            source: new WMTS({
              url: metadata.url,
              format,
              version,
              crossOrigin: '',
              projection: CRS,
              matrixSet: CRS,
              tileGrid: new WMTSTileGrid(metadata.parameters.options),
              wrapX: true,
              style: '',
              layer: Array.isArray(metadata.service_layers_names)
                ? metadata.service_layers_names.join()
                : metadata.service_layers_names,
              ...(credentials
                ? {
                    tileLoadFunction: (tile, src) => {
                      // Chrome stopped supporting URLs with embedded credentials, like https://user:pass@host
                      // So regex it and add to the request header
                      serviceLayerWithCredentialsLoader(tile, src, credentials);
                    },
                  }
                : {}),
            }),
          });
        }
        case 'empty': {
          return;
        }
        default: {
          throw new Error('Invalid metadata structure');
        }
      }
    },
  },
};
